/**
 * Application entry for mid-match inventory item use (consumables + actives).
 * Delegates to domain InventorySystem; no presentation coupling.
 */
export function useInventoryItem(inventory, slotIndex, options = {}) {
  if (!inventory || typeof inventory.useItem !== 'function') {
    return { success: false, reason: 'no_inventory' };
  }
  const success = inventory.useItem(slotIndex, options) === true;
  return { success };
}
